
























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";
import AreaPicker from "@/components/areapicker.vue";
import _ from "lodash";
import fileSaver from "file-saver";
import moment from "moment";

import { isAI, isCooperate, isTelBooking } from "@/libs/utils";
import Edit from "./edit.vue";
import Info from "./info.vue";
import TSUpload from "./upload.vue";
import Ground from "./ground.vue";
import Notes from "./notes.vue";

@Component({
  components: {
    AreaPicker,
    Edit,
    Info,
    TSUpload,
    Ground,
    Notes
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  orderwayOptions: any[] = [
    { label: "电话", value: "电话" },
    { label: "第三方订场平台", value: "第三方订场平台" },
    { label: "自有订场平台", value: "自有订场平台" },
    { label: "个人微信", value: "个人微信" },
    { label: "现场订场", value: "现场订场" }
  ];

  groundModalVisible = false;

  baseInfoForm!: any;

  detailForm!: any;

  baiduMap = false;

  baiduMapPoint: any = {
    lng: 0,
    lat: 0
  };

  baiduMapZoom = 15;

  onlinestatuslogs: any[] = [];

  stadium: { [t: string]: any } = {};

  tags: { [t: string]: any } = {};

  identity_card_picList: string[] = [];

  stadium_front_list: any[] = [];

  stadium_env_list: any[] = [];

  media_list: string[] = [];

  media_list1: any[] = [];

  thumbnails_list: any[] = [];

  ai_status = false;

  order_status = false;

  phone_status = false;

  price_version = 1;

  price_desc: any[] = [];

  monthly_avg_earning = 0;

  month_earning_top = 0;

  month_earning_under = 0;

  retail_food_earning = 0;

  rent_cost = 0;

  members_payment = 0;

  utilities = 0;

  qrcode = "";

  downqrcodeurl = "";

  report_path_ai = "";

  report_path_online = "";

  report_roll_screen = "";

  report_down_qrcode = "";

  miniprogram_qrcode = "";

  rent_date_start_month = 0;

  rent_date_end_month = 0;

  principal_identity_card_person_pic: any = "";

  beforeCreate() {
    this.baseInfoForm = this.$form.createForm(this);
    this.detailForm = this.$form.createForm(this);
  }

  mapAction(mark: number) {
    let mapStr = "";
    if (mark === 1) {
      // https://ditu.amap.com/regeo?lng=121.287689&lat=31.234527&name=park&src=mypage&callnative=0
      mapStr = `https://ditu.amap.com/regeo?lng=${this.formData.lng}&lat=${this.formData.lat}&name=${this.formData.stadium_name}&src=''&callnative=0`;
    } else if (mark === 2) {
      mapStr =
        `http://api.map.baidu.com/marker?location=${this.formData.lat},${this.formData.lng}&title=${this.formData.stadium_name}&content='` +
        "&output=html&src=webapp.baidu.openAPIdemo";
    } else {
      mapStr = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${this.formData.lat},${this.formData.lng};title:${this.formData.stadium_name};addr:.&referer=myapp`;
    }
    window.open(mapStr);
  }

  videoAction() {
    this.openVideoToNewBroswer(this.formData.sign_video);
  }

  changeImage(fieldname: string, value: any[]) {
    if (value) {
      let str = "";
      for (const obj of value) {
        str += `${obj.name},`;
      }
      // console.log(str)
      this.baseInfoForm.setFieldsValue({
        [fieldname]: _.trimEnd(str, ",")
      });
    }
  }

  async mounted() {
    this.spinLoading = true;
    const val = this.stadiumId;
    const res1 = await this.$store.dispatch("stadium/getTags", {});
    if (res1 && res1.Data) {
      this.tags = res1.Data;
    }
    // console.log(this.tags)
    const res = await this.$store.dispatch("stadium/getStadium", {
      stadium_id: val
    });
    // console.log(res);
    if (res && res.Data) {
      this.stadium = JSON.parse(JSON.stringify(res.Data));
      // console.log(this.stadium)

      if (!_.has(this.stadium, "stadium_info")) {
        this.stadium.stadium_info = {};
      }
      if (!_.has(this.stadium, "stadium_detail")) {
        this.stadium.stadium_detail = {};
      }

      if (this.stadium.stadium_detail.order_ways) {
        this.stadium.stadium_detail.order_ways = this.stadium.stadium_detail.order_ways.split(
          "、"
        );
      }

      if (this.stadium.stadium_detail.rent_date_start) {
        this.rent_date_start_month = moment().diff(
          moment(this.stadium.stadium_detail.rent_date_start),
          "months"
        );
      }

      if (this.stadium.stadium_detail.rent_date_end) {
        this.rent_date_end_month = Math.abs(
          moment().diff(
            moment(this.stadium.stadium_detail.rent_date_end),
            "months"
          )
        );
      }

      this.monthly_avg_earning =
        this.stadium.stadium_detail.monthly_avg_earning / 100;
      this.month_earning_top =
        this.stadium.stadium_detail.month_earning_top / 100;
      this.month_earning_under =
        this.stadium.stadium_detail.month_earning_under / 100;

      this.retail_food_earning =
        this.stadium.stadium_detail.retail_food_earning / 100;
      this.rent_cost = this.stadium.stadium_detail.rent_cost / 100;
      this.members_payment = this.stadium.stadium_detail.members_payment / 100;
      this.utilities = this.stadium.stadium_detail.utilities / 100;
      // 省市区
      const areastr: string[] = [];
      if (res.Data.stadium_info.province_id) {
        areastr.push(res.Data.stadium_info.province_id.toString());
      }
      if (res.Data.stadium_info.city_id) {
        areastr.push(res.Data.stadium_info.city_id.toString());
      }
      // console.log(res.data.stadium_info);
      if (res.Data.stadium_info.county_id) {
        areastr.push(res.Data.stadium_info.county_id.toString());
      }
      // console.log(areastr);
      this.stadium.stadium_info["areastr" as string] = areastr;
      this.baiduMapPoint = {
        lng: this.stadium.stadium_info.longitude,
        lat: this.stadium.stadium_info.latitude
      };
      // 场馆时段价格
      this.price_desc = res.Data.stadium_enter_apply.price_desc
        ? JSON.parse(res.Data.stadium_enter_apply.price_desc)
        : [];
      // console.log(this.price_desc[0].ground);
      if (_.isUndefined(_.find(this.price_desc, "week_to"))) {
        // 旧的价格提交
        this.price_version = 1;
      } else {
        // 新的价格提交
        this.price_version = 2;
      }
      // 配套设施
      this.stadium.stadium_info["tags" as string] = _.map(
        this.stadium.tags,
        "id"
      );
      this.ai_status = !!isAI(this.stadium.stadium_info);
      this.order_status = !!isCooperate(this.stadium.stadium_info);
      this.phone_status =
        _.indexOf([2, 6, 10, 14], this.stadium.stadium_info.online_status) !==
        -1;
      // 营业执照
      if (this.stadium.stadium_detail.business_license) {
        this.getImageUrl(this.stadium.stadium_detail.business_license).then(
          (url: any) => {
            this.stadium.stadium_detail.business_license = url;
          }
        );
      }
      // 手持营业执照
      if (this.stadium.stadium_detail.manager_business_license) {
        this.getImageUrl(
          this.stadium.stadium_detail.manager_business_license
        ).then((url: any) => {
          this.stadium.stadium_detail.manager_business_license = url;
        });
      }
      if (this.stadium.stadium_detail.principal_identity_card_person_pic) {
        this.getImageUrl(
          this.stadium.stadium_detail.principal_identity_card_person_pic
        ).then((url: any) => {
          this.principal_identity_card_person_pic = url;
        });
      }
      // 身份证正反照
      const { identity_card_pic } = this.stadium.stadium_detail;
      if (identity_card_pic) {
        const identity_card_picList = identity_card_pic.split(",");
        this.identity_card_picList = [];
        // @ts-ignore
        identity_card_picList.forEach((path: any) => {
          // @ts-ignore
          this.getImageUrl(path).then((url: any) => {
            this.identity_card_picList.push(String(url));
          });
        });
      }

      // 场馆环境照片
      this.stadium_env_list = [];
      const { stadium_env } = this.stadium.stadium_detail;
      // console.log(stadium_env);
      if (stadium_env) {
        // @ts-ignore
        const stadium_env_arry: string[] = stadium_env.split(",");
        stadium_env_arry.forEach((path, idx) => {
          // @ts-ignore
          this.stadium_env_list.push({
            uid: `env${idx}`,
            name: path,
            url: this.commonUrl(path),
            status: "done"
          });
        });
      }
      // 场馆前门照片
      this.stadium_front_list = [];
      const { stadium_front } = this.stadium.stadium_detail;
      // console.log(stadium_front);
      if (stadium_front) {
        // @ts-ignore
        const stadium_front_arry: string[] = stadium_front.split(",");
        stadium_front_arry.forEach((path, idx) => {
          // @ts-ignore
          this.stadium_front_list.push({
            uid: `front${idx}`,
            name: path,
            url: this.commonUrl(path),
            status: "done"
          });
        });
      }
      // 轮播图
      this.media_list = [];
      this.media_list1 = [];
      if (this.stadium.stadium_info.media) {
        const media_arr: string[] = this.stadium.stadium_info.media.split(",");
        for (const k in media_arr) {
          if (_.get(media_arr, [k])) {
            const itm = media_arr[k];
            this.media_list.push(this.commonUrl(itm));
            this.media_list1.push({
              uid: `media${k}`,
              name: itm,
              url: this.commonUrl(itm),
              status: "done"
            });
          }
        }
      }
      // 轮播图缩略图
      this.thumbnails_list = [];
      if (this.stadium.stadium_info.thumbnails) {
        const thumbnails_arr: string[] = this.stadium.stadium_info.thumbnails.split(
          ","
        );
        for (const k in thumbnails_arr) {
          if (_.get(thumbnails_arr, [k])) {
            const itm = thumbnails_arr[k];
            this.thumbnails_list.push({
              uid: `thumbnail${k}`,
              name: itm,
              url: this.commonUrl(itm),
              status: "done"
            });
          }
        }
      }

      if (this.stadium.stadium_detail.report_path_ai) {
        this.report_path_ai = this.stadium.stadium_detail.report_path_ai;
      }
      if (this.stadium.stadium_detail.report_path_online) {
        this.report_path_online = this.stadium.stadium_detail.report_path_online;
      }
      if (this.stadium.stadium_detail.report_down_qrcode) {
        this.report_down_qrcode = this.stadium.stadium_detail.report_down_qrcode;
      }
      if (this.stadium.stadium_detail.report_roll_screen) {
        this.report_roll_screen = this.stadium.stadium_detail.report_roll_screen;
      }
      if (this.stadium.stadium_detail.miniprogram_qrcode) {
        this.miniprogram_qrcode = this.stadium.stadium_detail.miniprogram_qrcode;
      }
      // if (this.stadium.stadium_info.ori_business_time_desc) {
      // console.log(this.stadium.stadium_info.ori_business_time_desc)
      // const oribusinesstimedesc = JSON.parse(this.stadium.stadium_info.ori_business_time_desc);
      // this.stadium.stadium_info.ori_business_time_desc = oribusinesstimedesc.join("\n")
      // }

      this.stadiumId = val;

      // 加载online_status_logs
      const res3 = await this.$store.dispatch("stadium/getOnlineStatusLogs", {
        stadium_id: val
      });

      this.onlinestatuslogs = [];
      if (res3 && res3.Data) {
        this.onlinestatuslogs = res3.Data;
      }
      this.spinLoading = false;
      const res8 = await this.$store.dispatch("stadium/downqrcode", {
        stadium_id: val
      });
      if (res8 && res8.Data) {
        this.downqrcodeurl = res8.Data;
      }
      // const res4 = await this.$store.dispatch('stadium/getQrcode', {
      //   stadium_id: val
      // })

      // console.log(res4)
      // if (res4 && res4.Message === 'success') {
      //   this.qrcode = `data:image/png;base64,${res4.Data}`
      // }

      // const res5 = await this.$store.dispatch('stadium/rollscreenimage', {
      //   stadium_id: val
      // })
      // console.log(res5)
      // const res6 = await this.$store.dispatch('stadium/rollscreenimage', {})
    }
  }

  changeOnlineStatus(item: string, val: boolean) {
    switch (item) {
      case "ai":
        this.$confirm({
          title: "确认信息",
          content: `确定要${val ? "上线" : "下线"}智能场馆？`,
          onOk: () => {
            if (val) {
              this.$store.dispatch("stadium/aiOnline", { id: this.stadiumId });
            } else {
              this.$store.dispatch("stadium/aiOffline", {
                id: this.stadiumId
              });
            }
            this.$message.success("操作成功");
            this.ai_status = val;
          },
          onCancel: () => {
            this.ai_status = val ? false : val;
          }
        });
        break;
      case "order":
        this.$confirm({
          title: "确认信息",
          content: `确定要${val ? "上线" : "下线"}订场平台？`,
          onOk: () => {
            if (val) {
              this.$store.dispatch("stadium/orderOnline", {
                id: this.stadiumId
              });
            } else {
              this.$store.dispatch("stadium/orderOffline", {
                id: this.stadiumId
              });
            }
            this.$message.success("操作成功");
            this.order_status = val;
          },
          onCancel: () => {
            this.order_status = val ? false : val;
          }
        });
        break;
      case "phone":
        this.$confirm({
          title: "确认信息",
          content: `确定要${val ? "上线" : "下线"}电话订场？`,
          onOk: () => {
            if (val) {
              this.$store.dispatch("stadium/phoneOnline", {
                id: this.stadiumId
              });
            } else {
              this.$store.dispatch("stadium/phoneOffline", {
                id: this.stadiumId
              });
            }
            this.$message.success("操作成功");
            this.phone_status = val;
          },
          onCancel: () => {
            this.phone_status = val ? false : val;
          }
        });
        break;
    }
  }

  aiOnlineNotice() {
    this.$confirm({
      title: "确认消息",
      content: "确定要发送ai馆上线通知吗？",
      onOk: async () => {
        // this.$Message.info('Clicked ok');
        const res = await this.$store.dispatch("stadium/aiOnlineNotice", {
          id: this.stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("通知成功");
        } else {
          this.$message.error("通知失败");
        }
      },
      onCancel: () => {
        // this.$Message.info('Clicked cancel');
      }
    });
  }

  orderOnlineNotice() {
    this.$confirm({
      title: "确认消息",
      content: "确定要发送订场平台上线通知吗？",
      onOk: async () => {
        // this.$Message.info('Clicked ok');
        const res = await this.$store.dispatch("stadium/orderOnlineNotice", {
          id: this.stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("通知成功");
        } else {
          this.$message.error("通知失败");
        }
      },
      onCancel: () => {
        // this.$Message.info('Clicked cancel');
      }
    });
  }

  async handleSubmit(name: string) {
    if (name === "baseInfo") {
      let province_id = 0;
      let city_id = 0;
      let county_id = 0;

      // console.log(this.stadium.stadium_info.areastr)

      if (this.stadium.stadium_info.areastr.length > 2) {
        county_id = _.parseInt(this.stadium.stadium_info.areastr[2]);
      }
      if (this.stadium.stadium_info.areastr.length > 1) {
        city_id = _.parseInt(this.stadium.stadium_info.areastr[1]);
      }
      if (this.stadium.stadium_info.areastr.length > 0) {
        province_id = _.parseInt(this.stadium.stadium_info.areastr[0]);
      }

      if (province_id === 0 && city_id === 0) {
        this.$message.error("省市不能为空");
        return;
      }

      await this.$store.dispatch("stadium/updateWithFields", {
        stadium_id: this.stadiumId,
        fields: [
          "name",
          "addr",
          "province_id",
          "city_id",
          "county_id",
          "ori_business_time_desc"
        ],
        stadium_json: JSON.stringify({
          name: this.stadium.stadium_info.name,
          addr: this.stadium.stadium_info.addr,
          province_id,
          city_id,
          county_id,
          ori_business_time_desc: JSON.stringify(
            this.stadium.stadium_info.ori_business_time_desc.split("\n")
          )
        })
      });

      await this.$store.dispatch("stadium/saveStadiumDetail", {
        id: this.stadium.stadium_detail.id,
        stadium_detail: JSON.stringify({
          order_phones: this.stadium.stadium_detail.order_phones,
          complaint_mobile: this.stadium.stadium_detail.complaint_mobile,
          order_ways: this.stadium.stadium_detail.order_ways,
          ground_count: this.stadium.stadium_detail.ground_count,
          stadium_size: this.stadium.stadium_detail.stadium_size,
          ground_height: this.stadium.stadium_detail.ground_height,
          remark: this.stadium.stadium_detail.remark
        })
      });

      await this.$store.dispatch("stadium/saveStadiumTags", {
        stadium_id: this.stadiumId,
        tag_ids: this.stadium.stadium_info.tags
      });

      this.$message.success("操作成功");
    } else if (name === "otherinfo") {
      let media = "";
      let thumbnails = "";

      for (const itm of this.media_list1) {
        media += `${itm.name},`;
      }

      for (const itm of this.thumbnails_list) {
        thumbnails += `${itm.name},`;
      }

      // console.log(this.stadium.stadium_info.longitude)
      // console.log(this.stadium.stadium_info.latitude)
      // console.log(_.trimEnd(media, ','))
      // console.log(_.trimEnd(thumbnails, ','))
      await this.$store.dispatch("stadium/updateWithFields", {
        stadium_id: this.stadiumId,
        fields: ["media", "thumbnails"],
        stadium_json: JSON.stringify({
          media: _.trimEnd(media, ","),
          thumbnails: _.trimEnd(thumbnails, ",")
        })
      });
      this.$message.success("操作成功");
    }
  }

  downqrcode() {
    const parts = this.qrcode.split(";base64,");
    const contentType = parts[0].split(":")[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    const blob = new Blob([uInt8Array], {
      type: contentType
    });

    fileSaver.saveAs(blob, `stadium${this.stadiumId}.png`);
  }

  async setMediaStatus(val: any, id: number) {
    this.$confirm({
      title: "确认信息",
      content: `您确定要${
        val === true ? "审核通过" : "审核不通过"
      }该场馆的轮播图和缩略图吗？`,
      onOk: async () => {
        // if (!this.checkPermission('admin-stadiums-edit')) {
        //   this.$message.warning('没有权限')
        //   return
        // }
        const res = await this.$store.dispatch("stadium/mediastatus", {
          id,
          val
        });
        // console.log(res)
        if (res && res.Message && res.Message === "success") {
          if (val === true) {
            this.stadium.stadium_info.media_status = 1;
          } else {
            this.stadium.stadium_info.media_status = 0;
          }
          this.$message.success("操作成功");
          // this.loadData()
        } else {
          this.$message.error("操作失败");
        }
      }
    });
  }

  updateMaterial(field: string) {
    let msg = "";
    switch (field) {
      case "report_path_ai":
        msg = "智能场馆正式营业海报";
        break;
      case "report_path_online":
        msg = "场馆上线海报";
        break;
      case "report_down_qrcode":
        msg = "球友端专用订场二维码";
        break;
      case "report_roll_screen":
        msg = "球友端订场App宣传资料";
        break;
      case "miniprogram_qrcode":
        msg = "小程序二维码";
        break;
    }
    this.$confirm({
      title: "确认消息",
      content: `确定更新${msg}吗？`,
      onOk: async () => {
        const res = await this.$store.dispatch(
          `stadium/${field.replace(/\_/g, "")}`,
          {
            stadium_id: this.stadiumId
          }
        );
        if (res && res.Message && res.Message === "success") {
          _.set(this, [field], res.Data);
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  getFilename(url: string): string {
    let filename = "";

    filename = url.substring(url.lastIndexOf("/") + 1);

    filename = filename.substring(0, filename.lastIndexOf("."));

    return filename;
  }

  showGroundModal() {
    // this.stadiumId = id
    this.groundModalVisible = true;
  }

  hideGroundModal() {
    this.groundModalVisible = false;
  }
}
